export const DECRYPT_URL_REQUEST = 'html/DECRYPT_URL_REQUEST';
export const DECRYPT_URL_SUCCESS = 'html/DECRYPT_URL_SUCCESS';
export const DECRYPT_URL_FAILURE = 'html/DECRYPT_URL_FAILURE';

export const FETCH_HTML_REQUEST = 'html/FETCH_HTML_REQUEST';
export const FETCH_HTML_SUCCESS = 'html/FETCH_HTML_SUCCESS';
export const FETCH_HTML_FAILURE = 'html/FETCH_HTML_FAILURE';

export const FETCH_TEMPLATE_REQUEST = 'html/FETCH_TEMPLATE_REQUEST';
export const FETCH_TEMPLATE_SUCCESS = 'html/FETCH_TEMPLATE_SUCCESS';
export const FETCH_TEMPLATE_FAILURE = 'html/FETCH_TEMPLATE_FAILURE';

export const UPDATE_HTML_REQUEST = 'html/UPDATE_HTML_REQUEST';
export const UPDATE_HTML_SUCCESS = 'html/UPDATE_HTML_SUCCESS';
export const UPDATE_HTML_FAILURE = 'html/UPDATE_HTML_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/html/constants.js